import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading as commonLoading } from 'store/common';

import { addDistribution as addTask } from './helpers';

import { IReducer, AppThunk } from 'store/types';
import { IDistributionBlock, IParamsReq, ITaskData } from 'types';
import { INewTask } from 'pages/Timesheet/TimesheetApartments/types';

interface IDistributionStore {
  list: IDistributionBlock[];
  loading: boolean;
}

interface IDateOptions {
  end?: string;
  project?: number | string;
}

const initialState: IDistributionStore = {
  list: [],
  loading: false,
};

const reset: CaseReducer<IDistributionStore> = () => initialState;

const loading: IReducer<IDistributionStore, boolean> = commonLoading;

const list: CaseReducer<IDistributionStore, PayloadAction<IDistributionBlock[]>> = (
  state,
  action,
) => {
  state.list = action.payload.filter(item => item?.appointments?.length);
};

export const distributionSlice = createSlice({
  name: 'OVP/distribution',
  initialState,
  reducers: {
    reset,
    loading,
    list,
  },
});

const {
  reset: setDistReset,
  loading: setDistLoading,
  list: setDistribution,
} = distributionSlice.actions;

export const fetchDistribution =
  (options: IDateOptions | IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setDistLoading(true));

    get<IDistributionBlock[]>('/api/timesheet/appointments/grouped/', options)
      .then(({ data }) => {
        dispatch(setDistribution(data));
      })
      .finally(() => dispatch(setDistLoading(false)));
  };

export const updateDistribution =
  (project: number): AppThunk =>
  (dispatch, getState) => {
    const { timesheet } = getState();
    const { loadingOvp } = timesheet;
    const { key: date } = loadingOvp.date.currentDate;

    dispatch(fetchDistribution({ project: project, end: date }));
  };

export const deleteDistributionStoreItem =
  (item: INewTask): AppThunk =>
  (dispatch, getState) => {
    const { timesheet } = getState();
    const { loadingOvp } = timesheet;
    const newData = loadingOvp.distribution.list.map(el => {
      return {
        ...el,
        appointments: el.appointments.filter(appointment => appointment.id !== item.appointment),
      };
    });

    dispatch(setDistribution(newData));
  };

export const getDistribution =
  (options: IDateOptions): AppThunk =>
  dispatch => {
    dispatch(fetchDistribution(options));
  };

export const addDistribution =
  (task: ITaskData): AppThunk =>
  (dispatch, getState) => {
    const { timesheet } = getState();
    const { loadingOvp } = timesheet;

    dispatch(
      setDistribution(
        loadingOvp.distribution.list.map(
          addTask({ dropId: task.id, dropParentId: task.sectionId }, task),
        ),
      ),
    );
  };

export { setDistReset, setDistribution };
